import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApplicationData, ApplyState } from 'src/types/flow';

const INITIAL_STATE: ApplyState = {
  applicationLoading: false,
  applicationError: '',
  applicationFinished: false,
  applicationData: {},
  applicationNumber: '',
};

export const taxCertificateSlice = createSlice({
  name: 'taxCertificate',
  initialState: INITIAL_STATE,
  reducers: {
    startTaxCertApplication: (
      state,
      action: PayloadAction<ApplicationData>
    ) => {
      state.applicationLoading = true;
      state.applicationData = { ...action.payload, ...state.applicationData };
    },
    setTaxCertApplicationError: (state, action: PayloadAction<string>) => {
      state.applicationLoading = false;
      state.applicationError = action.payload;
      state.applicationFinished = false;
    },
    finishTaxCertApplication: (state) => {
      state.applicationFinished = true;
    },
    setTaxCertApplicationLoading: (state, action: PayloadAction<boolean>) => {
      state.applicationLoading = action.payload;
    },
    clearTaxCertApplication(state) {
      state.applicationError = '';
      state.applicationFinished = false;
      state.applicationLoading = false;
      state.applicationNumber = '';
    },
    updateTaxCertApplicationData: (state, action) => {
      state.applicationData = {
        ...state.applicationData,
        ...action.payload,
      };
    },
    clearTaxCertDataExceptProperty: (state) => {
      const property = state.applicationData?.property;
      state.applicationData = { property };
    },
    setTaxCertApplicationNumber: (state, action) => {
      state.applicationNumber = action.payload;
    },
    resetTaxCertState: () => INITIAL_STATE,
  },
});

export const {
  startTaxCertApplication,
  setTaxCertApplicationError,
  finishTaxCertApplication,
  setTaxCertApplicationLoading,
  clearTaxCertApplication,
  updateTaxCertApplicationData,
  clearTaxCertDataExceptProperty,
  setTaxCertApplicationNumber,
  resetTaxCertState,
} = taxCertificateSlice.actions;

export default taxCertificateSlice.reducer;
